<div class="dropdown-items">
    <div class="dropdown">
        <angular2-multiselect [data]="countryList"
                              [(ngModel)]="selectedCountryList"
                              [settings]="dropdownCountrySettings"
                              (onSelect)="onCountryItemSelect($event)"
                              (onDeSelect)="OnCountryItemDeSelect($event)"
                              (onSelectAll)="onCountrySelectAll($event)"
                              (onDeSelectAll)="onCountryDeSelectAll($event)"
                              (onFilterSelectAll)="onCountryFilterSelectAll($event)"
                              (onFilterDeSelectAll)="onCountryFilterDeSelectAll($event)">
        </angular2-multiselect>
    </div>
    <div class="dropdown">
        <angular2-multiselect [data]="stateList"
                              [(ngModel)]="selectedStateList"
                              [settings]="dropdownStateSettings"
                              (onSelect)="onStateItemSelect($event)"
                              (onDeSelect)="OnStateItemDeSelect($event)"
                              (onSelectAll)="onStateSelectAll($event)"
                              (onDeSelectAll)="onStateDeSelectAll($event)"
                              (onFilterSelectAll)="onStateFilterSelectAll($event)"
                              (onFilterDeSelectAll)="onStateFilterDeSelectAll($event)">
        </angular2-multiselect>
    </div>
    <div class="dropdown">
        <angular2-multiselect [data]="countyList"
                              [(ngModel)]="selectedCountyList"
                              [settings]="dropdownCountySettings">
                            <!--(onSelect)="onCountyItemSelect($event)"
                            (onDeSelect)="OnCountyItemDeSelect($event)"
                            (onSelectAll)="onCountySelectAll($event)"
                            (onDeSelectAll)="onCountyDeSelectAll($event)">-->
        </angular2-multiselect>
    </div>
</div>

